import {inject, Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {IDataResponseModel} from '../models/data-response-model';
import {GetUnitByUserIdResponse} from './models/unit-by-user-id';

@Injectable({
  providedIn: 'root'
})
export class UnitService extends BaseService {
  private readonly _apiUrl: string = `${environment.uri}/admin/unit`;
  private readonly _http: HttpClient = inject(HttpClient);

  constructor() {
    super();
  }

  public getUnitByUserId(userId: number): Observable<GetUnitByUserIdResponse[]> {
    return this._http.get<GetUnitByUserIdResponse[]>(`${this._apiUrl}/get-by-userId/${userId}`);
  }

  public setSelectedUnit(selectedUnit: GetUnitByUserIdResponse): void {
    const value = JSON.stringify(selectedUnit);
    localStorage.setItem('unit', btoa(value));
  }

  public getSelectedUnit(): GetUnitByUserIdResponse | null {
    const unit = localStorage.getItem('unit');

    if (!unit)
      return null;

    return JSON.parse(atob(unit)) as GetUnitByUserIdResponse;
  }
}
